import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-end" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "formgrid grid" }
const _hoisted_4 = { class: "field col-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "startStation",
  class: "col-fixed text-sm",
  style: {"display":"block"}
}, " 発駅 ", -1)
const _hoisted_6 = { class: "field col-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "endStation",
  class: "col-fixed text-sm",
  style: {"display":"block"}
}, " 着駅 ", -1)
const _hoisted_8 = { class: "field col-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "boundFor",
  class: "col-fixed text-sm",
  style: {"display":"block"}
}, " 方面 ", -1)
const _hoisted_10 = { class: "field col-4 p-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "next-nextDepartureTime",
  class: "col-fixed text-sm",
  style: {"display":"block"}
}, " 次発 ", -1)
const _hoisted_12 = { class: "field col-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "turn-cycle-nextDepartureTime",
  class: "col-fixed text-sm p-0",
  style: {"display":"block"}
}, [
  /*#__PURE__*/_createTextVNode(" 折返周期"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "(分)")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "isShowPreview" }, "プレビューを表示する", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_DiagramTimeTableManagerCopyFromOtherTrain = _resolveComponent("DiagramTimeTableManagerCopyFromOtherTrain")!
  const _component_DiagramTimeTableManagerTable = _resolveComponent("DiagramTimeTableManagerTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    header: "時刻",
    class: "my-2"
  }, {
    icons: _withCtx(() => []),
    default: _withCtx(() => [
      (_ctx.selectedDiagramDataSet)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Button, {
                onClick: _ctx.deleteTrain,
                icon: "pi pi-ban",
                label: "編成削除",
                class: "p-button-sm p-button-warning"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("p", _hoisted_2, [
              _createElementVNode("span", {
                style: _normalizeStyle({ color: _ctx.trainType?.lineColor })
              }, "■", 4),
              _createTextVNode(" " + _toDisplayString(_ctx.selectedDiagramDataSet.label), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Dropdown, {
                  id: "startStation",
                  modelValue: _ctx.startStation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startStation) = $event)),
                  options: _ctx.shouldRecordTimeStoppingStationList,
                  optionLabel: "name",
                  optionValue: "id",
                  class: "w-10 text-left"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Dropdown, {
                  id: "endStation",
                  modelValue: _ctx.endStation,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endStation) = $event)),
                  options: _ctx.endStationOptions,
                  optionLabel: "name",
                  optionValue: "id",
                  optionDisabled: "disabled",
                  class: "w-10 text-left"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Dropdown, {
                  id: "boundFor",
                  modelValue: _ctx.boundFor,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.boundFor) = $event)),
                  options: _ctx.boundForOptions,
                  optionLabel: "key",
                  optionValue: "key",
                  optionDisabled: "disabled",
                  class: "w-10 text-left"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_TimePicker, {
                  id: "next-nextDepartureTime",
                  modelValue: _ctx.nextDepartureTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nextDepartureTime) = $event)),
                  class: "w-10"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_InputNumber, {
                  id: "turn-cycle-nextDepartureTime",
                  mode: "decimal",
                  min: 1,
                  modelValue: _ctx.turnCycleTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.turnCycleTime) = $event)),
                  class: "w-10"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Checkbox, {
                id: "isShowPreview",
                binary: "",
                modelValue: _ctx.isShowPreview,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isShowPreview) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_14
            ]),
            _createVNode(_component_SplitButton, {
              label: "ふやす",
              onClick: _ctx.add,
              class: "p-button-sm my-2",
              model: [
          { label: '別列車からコピー', icon: 'pi pi-copy', command: _ctx.copyFrom },
        ]
            }, null, 8, ["onClick", "model"]),
            _createVNode(_component_DiagramTimeTableManagerCopyFromOtherTrain, {
              visible: _ctx.isVisibleCopyModal,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isVisibleCopyModal) = $event)),
              diagramDataSet: _ctx.selectedDiagramDataSet
            }, null, 8, ["visible", "diagramDataSet"]),
            _createVNode(_component_DiagramTimeTableManagerTable, {
              modelValue: _ctx.selectedDiagramDataSetData,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDiagramDataSetData) = $event)),
              id: "diagram-time-table"
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}